<template>
  <div class="footer">
     <div class="footers">
       <div class="footer01">
          <div class="foo01" style="line-height: 42px;">
            <div style="width: 100px;">
              友情链接：
            </div>
            <div style="display: flex;flex-wrap: wrap;">
              <span v-for="(item,i) in youqing" :key="i">
                 <a :href="item.url" style="color: #fff;">{{item.title}}</a>
              </span>
            </div>
          </div>
          <div class="you">
            ©2018 北京圣尚咨询服务有限公司 ® 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">京ICP备2023024835号-1</a>
          </div>
<!--          <div class="you" style="margin-top: 20px;">
              <a href="https://www.jiutiancx.com" target="_blank" style="color: #fff;text-decoration: none;">
                九天创想提供技术支持
              </a>
          </div> -->
       </div>

       <div class="footer02" v-if="ercode">
          <div class="footer02s">
            <div class="img">
                <img :src="ercode" alt="">
            </div>
            微信联系客服
          </div>
       </div>

     </div>
  </div>
</template>

<script>
import { isOddOrEvenDay } from "@/utils/rules.js"
import { ContantUser_index } from "@/api/gw/zonghe.js"
import { FriendUrl_index } from "@/api/gw/config.js"
  export default {
      data(){
        return{
           youqing:[

           ],//友情链接
           ercode:"",
        }
      },
      mounted(){
        this.ContantUser_index();
        this.FriendUrl_index();
      },
      methods: {
        ContantUser_index(){
          let type = isOddOrEvenDay();
          ContantUser_index({
            page:1,
            limit:2,
            status:1,
            type:type
          }).then(res=>{
            if(res.data.data && res.data.data.length>0){
						this.ercode = res.data.data[0].ercode
					}
          })
        },
        FriendUrl_index(){
          FriendUrl_index({
            page:1,
            limit:30,
          }).then(res=>{
            this.youqing = res.data.data
          })
        },
      }
  }
</script>

<style lang="scss" scoped>
.footer02{
  display: flex;
  margin-left: auto;
  .footer02s{
    width: 100px;
    text-align: center;
    .img{
      width: 100px;
      height: 100px;
      margin-bottom: 14px;
      display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #fff;
    img{
      width: 85px;
      height: 85px;
    }
    }
    color: #fff;
    font-size: 16px;
  }
}
.footer01{
  width: 91%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  .you{
    color: #fff;
    font-size: 18px;
    margin-top: 40px;
  }
  .foo01{
    color: #fff;
    font-size: 18px;
    display: flex;
    span{
      cursor: pointer;
      margin-right: 30px;
    }
  }
}
.footer{
  .footers{
    width: 1250px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  width: 100%;
  height: 230px;
  background: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue